import { Box } from "@mui/material";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom";
import BreadcrumbDynamic from "../../../components/BreadcrumbDynamic";
import { useAuthentication } from "../../../reducer/authentication";
import TicketsList from "./TicketsList";
import TicketsSideNav from "./TicketsSideNav";
import TicketsEditRoot from "./TicketsEditRoot";
import TicketsAdd from "./TicketsAdd";

interface TicketsProps {

}

export default function Tickets(props: TicketsProps) {
    const match = useRouteMatch();
    const history = useHistory();
    const { user } = useAuthentication();

    function onAddClick(prefix: string) {
        history.push(`${match.url}${prefix}/add`);
    }

    function onEditClick(id: number) {
        history.push(`${match.url}/${id}`);
    }
    return (
        <Box flex={1} display='flex' flexDirection='row' overflow='hidden'>
            <TicketsSideNav />
            <Box flex={1} display='flex' flexDirection='column' overflow='hidden' bgcolor='black' padding={1}>
                <BreadcrumbDynamic />
                <BreadcrumbsItem to={match.path}>
                    Chamados
                </BreadcrumbsItem>
                <Switch>
                    <Route path={`${match.url}/open`} exact ><TicketsList key={1} status={2} onAddClick={() => onAddClick('')} onEditClick={onEditClick} /></Route>
                    <Route path={`${match.url}/closed`} exact ><TicketsList key={2} status={3} onAddClick={() => onAddClick('')} onEditClick={onEditClick} /></Route>
                    <Route path={`${match.url}/newComments`} exact ><TicketsList key={4} status={8} onAddClick={() => onAddClick('')} onEditClick={onEditClick} /></Route>

                    <Route path={`${match.url}/add`} exact component={() => <TicketsAdd />} />
                    <Route path={`${match.url}/:id(\\d+)`}><TicketsEditRoot /></Route>
                </Switch>

            </Box>
        </Box>
    );
}